import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../common/shared.module';
import { FormsModule } from '@angular/forms';

import { UtlPerFinService } from './utl-per-fin.service';
import { UtlPerFinComponent } from './utl-per-fin.component';
import { UtlPerFinRoutingModule } from './utl-per-fin-routing.module';
import { MainHeaderComponent } from './components-utl-per-fin/main-header/main-header.component';
import { MainTableComponent } from './components-utl-per-fin/main-table/main-table.component';
import { SubsectionRowComponent } from './components-utl-per-fin/subsection-row/subsection-row.component';
import { SectionRowComponent } from './components-utl-per-fin/section-row/section-row.component';
import { DataCellComponent } from './components-utl-per-fin/data-cell/data-cell.component';
import { NumberCellComponent } from './components-utl-per-fin/number-cell/number-cell.component';
import { TableMainSectionComponent } from './components-utl-per-fin/table-main-section/table-main-section.component';
import { BsDropdownModule, TooltipModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [
    UtlPerFinComponent,
    MainHeaderComponent,
    MainTableComponent,
    SubsectionRowComponent,
    SectionRowComponent,
    DataCellComponent,
    NumberCellComponent,
    TableMainSectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    UtlPerFinRoutingModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  providers: [UtlPerFinService]
})
export class UtlPerFinModule {}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/utl-per-fin.module.ts